import BackIcon from "@styles/all-images/icons/back-button.svg";
import LiveChatScreen from "@/pages/LiveChat/LiveChatScreen";
import UserSearch from "@/pages/LiveChat/UserSearch";
import LiveChatStateProvider from "./Provider/LiveChatStateProvider";

const TierConfigurationModule = () => {
  return (
    <div className="tw-relative">
      <LiveChatStateProvider>
        <div className="tw-fixed tw-h-[68px] tw-top-[80px] tw-w-full tw-z-10">
          <div className="tw-px-8 tw-py-4 tw-bg-white tw-border-b tw-border-[#E9EAEB]">
            <div className="tw-grid tw-grid-cols-5 tw-justify-between tw-items-center">
              <div className="tw-flex tw-items-center tw-col-span-1">
                <a href="/">
                  <img src={BackIcon} alt="Back Icon" />
                </a>
                <h1 className="tw-text-[22px] tw-ml-4 tw-font-semibold tw-text-[#232323]">
                  Live Chat
                </h1>
              </div>
              <div className="tw-relative tw-col-span-1">
                <UserSearch />
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="tw-mt-[170px]">
          <LiveChatScreen />
        </div>
      </LiveChatStateProvider>
    </div>
  );
};

export default TierConfigurationModule;
